module.exports = __webpack_public_path__ + "static/media/04 Mintutes of Meeting  26 July 2023.27d1ab0b.pdf";